import { takeEvery, all, put, select } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'
import { push } from 'connected-react-router'

import { postActivity, deleteTempActivity } from '../actions'
import { CREATE_ACTIVITY_FORM_NAME as FORM_NAME } from 'app/constants/activities'
import { showSuccess } from 'store/entities/toastr/utils'
import { getViewProtrackId } from 'store/entities/protracks/selectors'
import { getLevelsView } from 'store/entities/protracks/levels/selectors'
import { getActivitiesViewPresenter } from 'store/entities/protracks/activities/selectors'
import { MICROACTIONS_PATH } from 'app/constants/navLinks.js'
import i18next from 'i18next'

export function* handlePostRequest() {
  yield put(startSubmit(FORM_NAME))
}

export function* handlePostSuccess({ payload: { data } }) {
  const protrackId = yield select(getViewProtrackId)
  const levelId = yield select(getLevelsView)
  const currentActivity = yield select(getActivitiesViewPresenter)
  if (currentActivity && currentActivity.get('fromFile')) {
    yield put(deleteTempActivity(currentActivity.get('id')))
  }
  yield put(
    push({
      pathname: `${MICROACTIONS_PATH}/protracks/${protrackId}/levels/${levelId}/activities`,
      state: { preventRequest: true, forceLeave: true },
    })
  )
  showSuccess({ content: i18next.t('You successfully created activity', { name: data.name }) })
}

export function* handlePostFail(error) {
  console.error('error', error)
  yield put(stopSubmit(FORM_NAME))
}

export default function* postActivitySaga() {
  yield all([
    takeEvery(postActivity.toString(), handlePostRequest),
    takeEvery(postActivity.success.toString(), handlePostSuccess),
    takeEvery(postActivity.fail.toString(), handlePostFail),
  ])
}
